/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to unlink your Minecraft account? You will no longer synchronize your Mojang profile when joining via offline launchers.`)
};

const zh_hans1_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定要解除 Minecraft 账号绑定吗？解除后，通过离线启动器登录时将无法同步正版档案与皮肤。`)
};

const zh_hant1_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確定要解除 Minecraft 帳號綁定嗎？解除後，透過離線啟動器登入時將無法同步正版檔案與皮膚。`)
};

const fr_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir dissocier votre compte Minecraft ? Les données de profil Mojang ne seront plus synchronisées lors des lancements hors ligne.`)
};

const de_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie Ihr Minecraft-Konto wirklich trennen? Ihre Mojang-Profildaten werden bei Offline-Starts nicht mehr synchronisiert.`)
};

const ja_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraftアカウントの連携を解除してもよろしいですか？オフラインランチャーからの参加時にプロファイルやスキンが同期されなくなります。`)
};

const ko_settings_minecraft_unlink_confirm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 계정 연동을 해제하시겠습니까? 해제 시 오프라인 런처 접속 시 정품 프로필 및 스킨이 동기화되지 않습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_unlink_confirm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_unlink_confirm(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_unlink_confirm", locale)
	if (locale === "en") return en_settings_minecraft_unlink_confirm(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_unlink_confirm(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_unlink_confirm(inputs)
	if (locale === "fr") return fr_settings_minecraft_unlink_confirm(inputs)
	if (locale === "de") return de_settings_minecraft_unlink_confirm(inputs)
	if (locale === "ja") return ja_settings_minecraft_unlink_confirm(inputs)
	return ko_settings_minecraft_unlink_confirm(inputs)
};